import { AlignItems, Body3, Box, Color, Display, RadiusScale } from '@gousto-internal/citrus-react'
import React from 'react'

type RecipeTagProps = {
  tagText: string
}

export const RecipeTag = ({ tagText }: RecipeTagProps) => {
  return (
    <Box
      display={Display.Flex}
      alignItems={AlignItems.Center}
      bg={Color.NeutralGrey_50}
      paddingH={2}
      paddingV={1}
      width="max-content"
      borderRadius={3 as RadiusScale}
    >
      <Body3>{tagText}</Body3>
    </Box>
  )
}
